module.exports = __webpack_public_path__ + "static/media/person_1.bbcd5413.jpg";